/**
 * 封路障碍物生效车范围工具
 *
 * 层级：views/MapEditor/utils（表单与展示公共工具）
 *
 * 职责：
 * 1. 判断 effectiveMapList 是否满足“仅高精车有效”规则
 * 2. 判断车辆生效范围中的部分生效选项是否应禁用
 * 3. 格式化 effectiveMapList 展示文案
 *
 * 不关心表单渲染、接口请求与地图覆盖物实现。
 */
import { AnchorLayerType, EffectiveMapType, EffectiveMapTypeText } from '@/utils/constant';

export type EffectiveMapValue = `${EffectiveMapType}`;

export const DEFAULT_EFFECTIVE_MAP_LIST: EffectiveMapType[] = [
  EffectiveMapType.LD_EFFECTIVE,
  EffectiveMapType.HD_EFFECTIVE,
];

export const getDefaultEffectiveMapList = (): EffectiveMapType[] => [
  ...DEFAULT_EFFECTIVE_MAP_LIST,
];

export const isHdOnlyEffectiveMap = (list?: string[] | null): boolean =>
  !!list?.includes(EffectiveMapType.HD_EFFECTIVE) &&
  !list.includes(EffectiveMapType.LD_EFFECTIVE);

export const shouldDisablePartialVehicleEffect = (
  type: AnchorLayerType,
  effectiveMapList?: string[] | null
): boolean => {
  const staticDisableTypes = [
    AnchorLayerType.ATTRIBUTE_ANNOTATION,
    AnchorLayerType.SPEED_LIMIT,
    AnchorLayerType.ROAD_TEST_FOCUS_AREA,
    AnchorLayerType.LD_ASSIST,
    AnchorLayerType.NAVIGATION,
    AnchorLayerType.NO_HORN_ZONE,
  ];

  if (staticDisableTypes.includes(type)) return true;
  if (type !== AnchorLayerType.ROAD_CLOSED) return false;
  return !isHdOnlyEffectiveMap(effectiveMapList);
};

const EFFECTIVE_MAP_SHORT_TEXT = new Map<EffectiveMapType, string>([
  [EffectiveMapType.LD_EFFECTIVE, '轻图'],
  [EffectiveMapType.HD_EFFECTIVE, '高精'],
]);

export const getEffectiveMapLabels = (list?: string[] | null): string[] =>
  list?.map(
    (value) =>
      EFFECTIVE_MAP_SHORT_TEXT.get(value as EffectiveMapType) ??
      EffectiveMapTypeText.get(value as EffectiveMapType) ??
      value
  ) ?? [];

export const formatEffectiveMapList = (list?: string[] | null): string =>
  getEffectiveMapLabels(list).join('、');
